module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

if(getLayoutClass() === 'side_left' || getLayoutClass() === 'side_right'){;
__p += '\n	<div id="interactive_region"></div>\n	<div id="widget_header_wrapper" class="' +
((__t = (getLayoutClass())) == null ? '' : __t) +
'">\n		<div id="widget_header_region"></div>\n		<div aria-label="Carousel of images with text descriptions and social media handles." id="coverflow_widget" class="wrap" role="region">\n			<div class="controls">\n				<div aria-label="' +
((__t = ( I18n.t('common.controls.previous') )) == null ? '' : __t) +
'" class="btn prev" role="button" tabindex="0"></div>\n				<div aria-label="' +
((__t = ( I18n.t('common.controls.next') )) == null ? '' : __t) +
'" class="btn next" role="button" tabindex="0"></div>\n			</div>\n			<div id="frame" class="coverflow_frame">\n			</div>\n		</div>\n	</div>\n';
} else { ;
__p += '\n	<div id="widget_header_region"></div>\n	<div id="interactive_region"></div>\n	<div aria-label="Carousel of images with text descriptions and social media handles." id="coverflow_widget" class="wrap" role="region">\n		<div class="controls">\n			<div aria-label="' +
((__t = ( I18n.t('common.controls.previous') )) == null ? '' : __t) +
'" class="btn prev" role="button" tabindex="0"></div>\n			<div aria-label="' +
((__t = ( I18n.t('common.controls.next') )) == null ? '' : __t) +
'" class="btn next" role="button" tabindex="0"></div>\n		</div>\n		<div id="frame" class="coverflow_frame">\n		</div>\n	</div>\n';
};
__p += '\n';

}
return __p
}